/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "./compat.component";
var styles_CompatComponent = [];
var RenderType_CompatComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_CompatComponent, data: {} });
export { RenderType_CompatComponent as RenderType_CompatComponent };
export function View_CompatComponent_0(_l) { return i0.ɵvid(0, [i0.ɵqud(402653184, 1, { entryPoint: 0 }), (_l()(), i0.ɵeld(1, 16777216, [[1, 3], ["entryPoint", 1]], null, 0, null, null, null, null, null, null, null)), (_l()(), i0.ɵeld(2, 16777216, null, null, 1, "router-outlet", [], null, null, null, null, null)), i0.ɵdid(3, 212992, null, 0, i1.RouterOutlet, [i1.ChildrenOutletContexts, i0.ViewContainerRef, i0.ComponentFactoryResolver, [8, null], i0.ChangeDetectorRef], null, null)], function (_ck, _v) { _ck(_v, 3, 0); }, null); }
export function View_CompatComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "webapp-compat", [], null, null, null, View_CompatComponent_0, RenderType_CompatComponent)), i0.ɵdid(1, 114688, null, 0, i2.CompatComponent, [[1, i0.Injector], i0.NgModuleFactoryLoader], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var CompatComponentNgFactory = i0.ɵccf("webapp-compat", i2.CompatComponent, View_CompatComponent_Host_0, {}, {}, []);
export { CompatComponentNgFactory as CompatComponentNgFactory };



// WEBPACK FOOTER //
// ./src/compat/compat.component.ngfactory.js.pre-build-optimizer.js